import { from as rxFrom } from "rxjs/observable/from";
import { tap, mergeMap, toArray } from "rxjs/operators";
import { AttributeLayout } from "../shaders/attribute-layout";
var Size = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
};
var Primitive = (function () {
    function Primitive(gl_context_, gltf_data_, material_loader_, buffer_loader_, primitive_data_) {
        this.gl_context_ = gl_context_;
        this.gltf_data_ = gltf_data_;
        this.material_loader_ = material_loader_;
        this.buffer_loader_ = buffer_loader_;
        this.primitive_data_ = primitive_data_;
        this.vertex_buffers_ = {};
    }
    ;
    Primitive.prototype.loadVertexData = function () {
        var _this = this;
        var buffer_indices = [];
        for (var name_1 in this.primitive_data_.attributes) {
            var accessor_index = this.primitive_data_.attributes[name_1];
            var accessor = this.gltf_data_.accessors[accessor_index];
            var buffer_view_index = accessor.bufferView;
            var buffer_index = this.gltf_data_.bufferViews[buffer_view_index].buffer;
            buffer_indices.push(buffer_index);
        }
        var unique_buffer_indices = Array.from(new Set(buffer_indices));
        return rxFrom(unique_buffer_indices)
            .pipe(mergeMap(function (buffer_index) { return _this.buffer_loader_.loadBuffer(buffer_index); }), toArray(), tap(function (buffers) { return _this.initVertexArray(_this.primitive_data_); }));
    };
    ;
    Primitive.prototype.loadMaterial = function () {
        var _this = this;
        return this.material_loader_.getMaterial(this.primitive_data_.material)
            .pipe(tap(function (material) { return _this.material_ = material; }));
    };
    ;
    Primitive.prototype.initVertexArray = function (primitive) {
        this.drawing_mode_ = primitive.mode || 4;
        this.vertex_array_object_ = this.gl_context_.createVertexArray();
        this.gl_context_.bindVertexArray(this.vertex_array_object_);
        var accessor = this.gltf_data_.accessors[primitive.attributes["POSITION"]];
        this.vertex_count_ = accessor.count;
        for (var attribute in primitive.attributes) {
            this.createBuffer(primitive.attributes[attribute]);
            this.enableAttribute(AttributeLayout[attribute], primitive.attributes[attribute]);
        }
        if (!primitive.attributes["NORMAL"]) {
        }
        if (!primitive.attributes["TANGENT"]) {
        }
        this.gl_context_.bindVertexArray(null);
    };
    ;
    Primitive.prototype.createBufferView = function (buffer_view_index) {
        var buffer_view = this.gltf_data_.bufferViews[buffer_view_index];
        var buffer = this.buffer_loader_.getBuffer(buffer_view.buffer);
        return buffer.slice(buffer_view.byteOffset, buffer_view.byteOffset + buffer_view.byteLength);
    };
    ;
    Primitive.prototype.draw = function (shader) {
        this.gl_context_.bindVertexArray(this.vertex_array_object_);
        this.material_.setMaterialUniforms(shader);
        this.gl_context_.drawArrays(this.drawing_mode_, 0, this.vertex_count_);
        this.gl_context_.bindVertexArray(null);
    };
    ;
    Primitive.prototype.enableAttribute = function (layout, accessor_index) {
        var accessor = this.gltf_data_.accessors[accessor_index];
        var buffer_view = this.gltf_data_.bufferViews[accessor.bufferView];
        this.gl_context_.enableVertexAttribArray(layout);
        this.gl_context_.vertexAttribPointer(layout, Size[accessor.type], accessor.componentType, accessor.normalized || false, buffer_view.byteStride || 0, accessor.byteOffset || 0);
    };
    ;
    Primitive.prototype.createBuffer = function (accessor_index) {
        var accessor = this.gltf_data_.accessors[accessor_index];
        var buffer_view_index = accessor.bufferView;
        var buffer = this.vertex_buffers_[buffer_view_index];
        if (!buffer) {
            buffer = this.gl_context_.createBuffer();
            this.gl_context_.bindBuffer(this.gl_context_.ARRAY_BUFFER, buffer);
            this.bufferData(buffer_view_index);
        }
        this.gl_context_.bindBuffer(this.gl_context_.ARRAY_BUFFER, buffer);
    };
    ;
    Primitive.prototype.bufferData = function (buffer_view_index) {
        var data = this.createBufferView(buffer_view_index);
        this.gl_context_.bufferData(this.gl_context_.ARRAY_BUFFER, data, this.gl_context_.STATIC_DRAW);
    };
    ;
    return Primitive;
}());
export { Primitive };
;
//# sourceMappingURL=primitive.js.map